export const MONTH_ABBREV_MAP: Record<string, string> = {
  Jan: "january",
  January: "january",
  Feb: "february",
  February: "february",
  Mar: "march",
  March: "march",
  Apr: "april",
  April: "april",
  May: "may",
  Jun: "june",
  June: "june",
  Jul: "july",
  July: "july",
  Aug: "august",
  August: "august",
  Sep: "september",
  September: "september",
  Oct: "october",
  October: "october",
  Nov: "november",
  November: "november",
  Dec: "december",
  December: "december",
};

export const translateMonthLabel = (
  label: string,
  t: (key: string) => string
): string => {
  const parts = label.split(" ");

  if (parts.length === 2) {
    const key = MONTH_ABBREV_MAP[parts[0]];

    if (key) {
      const fullName = t(key);
      const abbrev = fullName.slice(0, 3);
      const capitalized = abbrev.charAt(0).toUpperCase() + abbrev.slice(1).toLowerCase();

      return `${capitalized} ${parts[1]}`;
    }
  }

  return label;
};
